exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".h9TfH{background-color:#f7fff1;border:2px solid #289b18;border-radius:4px}._2Ia4a:hover{cursor:pointer}", ""]);

// exports
exports.locals = {
	"border": "h9TfH",
	"hover": "_2Ia4a"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"module":true,"modules":true,"localIdentName":"[hash:base64:5]"}!../node_modules/sass-loader/lib/loader.js?{"outputStyle":"collapsed","sourceMap":true,"includePaths":["/Users/markromero/Code/frn-platform-frontend/src"]}!./routes/Checkout/components/GiftRecipient/styles.scss
// module id = 1096
// module chunks = 0